import { useLocalSearchParams } from 'expo-router'

import { NameScreen } from '@/src/features/auth/ui/screens/NameScreen'
import { filterSearchParams } from '@/src/general/utils/filterSearchParams'

export default () => {
  const { redirectTo } = filterSearchParams(useLocalSearchParams())
  return <NameScreen redirectTo={redirectTo} />
}
